export default __webpack_public_path__ + "static/media/2.dae0fc05.jpg";